import React from 'react'

function Loader() {
    return (
        <>
            <div className="custom-loader">
                <div className="loader"></div>
            </div>
        </>
    )
}

export default Loader